import { Component, ViewChild, OnInit, NgZone } from '@angular/core';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { AdminMappingService } from 'src/app/admin-stock-mappings/admin-mappings.service';
import { UnMappedStock, Stock, CustomStock, StockType, NewCustomStockMapping, TyreStockToBeMapped, CustomStockToBeMapped, UsedStockClassification, UsedStockItemToBeMapped } from 'src/app/models/admin-mappings';
import { filteredStockItem } from 'src/app/models/stock';
import { NotificationService } from 'src/app/shared/notification.service';
import {AdminStockMappingsComponent} from 'src/app/admin-stock-mappings/admin-stock-mappings.component';
import { AuthService } from 'src/app/auth.service';
import { StockItem } from 'src/app/models/pricelist';

@Component({
  selector: 'app-modal-mapping',
  templateUrl: './modal-mapping.component.html',
  styleUrls: ['./modal-mapping.component.less']
})
export class ModalMappingComponent implements OnInit {
  @ViewChild('customStockSelect') customStockSelect: NzSelectComponent;

  //stockItem: UnMappedStock;
  selectedMap: Stock | null = null;
  selectedCustomMap: CustomStock | null;

  isMapping = false;
  isLoadingActiveStock = false;

  activeStock: Stock[] = [];
  activeStockTemp: Stock[] = [];
  activeStockVeryTemp: Stock[] = [];
  filterTerm: string = '';

  activeCustomStock: CustomStock[] = [];
  activeCustomStockTemp: CustomStock[] = [];
  filteredStock: filteredStockItem[] = [];
  unMappedStock: UnMappedStock[] = [];

  currentClientName: string = "";

  isCustomMappingTab = false;
  isAddCustomStockOpen: boolean = false;

  customStockTypes: StockType[] =[]

  customStockCode: string = '';
  customStockType: StockType = { id: 0, name: 'null', msfId: 0, isVisible: false };
  customDescription: string = '';


  isNmsfAddOpen:boolean = false;

  itemToAdd:StockItem = new StockItem();

  usedStockClassification: UsedStockClassification[];
  selectedUsedStockClassification: UsedStockClassification;
  selectedUsedStockClassificationId: number =1;
  constructor(
    public adminMappingService: AdminMappingService,
    private notification: NotificationService,
    private ngZone: NgZone,
    public adminStockMappingsComponent: AdminStockMappingsComponent,
    public authService : AuthService
  ) { }

  ngOnInit(): void {
    this.currentClientName = this.adminMappingService.currentClientName;
    this.isLoadingActiveStock = true;
    this.adminMappingService.getActiveStock().subscribe( (response : Stock[]) => {
      this.isLoadingActiveStock = false;
      this.activeStockTemp = response;
      this.activeStock = this.activeStockTemp;
      this.filterActiveStockAdvanced();
    }, (error) => {
      this.isLoadingActiveStock = false;
      this.notification.ShowAlert(error);
    });
    this.adminMappingService.getCustomStockTypes().subscribe(
      (stockTypes: StockType[]) => {
        this.adminMappingService.customStockTypes = stockTypes;
      },
      (error) => {
        this.notification.showError('Error fetching custom stock types', error);
      }
    );
    this.adminMappingService.getUsedStockClassifications().subscribe(
      (usedStockClassification: UsedStockClassification[]) => {
        this.usedStockClassification = usedStockClassification;
      },
      (error) => {
        this.notification.showError('Error fetching used stock classifications', error);
      }
    );
  }


  handleClose(): void {
    this.adminMappingService.currentVisibility = false;
  }


  setSelectedMap(stock: Stock) {
    this.ngZone.run(() => {
      this.selectedMap = stock;
    });
  }


  mapTyreStock(unmappedStockItem: UnMappedStock, msfIdOfExistingStock: number, stockTypeId: number, mapType: number, close: boolean, next: boolean) {
    this.isMapping = true;
    let tyreStockItem = new TyreStockToBeMapped();

    tyreStockItem.clientId = unmappedStockItem.clientId;
    tyreStockItem.description = unmappedStockItem.description;
    tyreStockItem.msfid = msfIdOfExistingStock;
    tyreStockItem.stockCode = unmappedStockItem.stockCode;

    this.adminMappingService.mapTyreStock(tyreStockItem).subscribe(res => {
      this.notification.showSuccess("Changes saved successfully");
      this.isMapping = false;
      this.selectedMap = null;
      if (close) {
        this.adminMappingService.currentVisibility = false;
      }

      if (next) {
        const currentIndex = this.adminStockMappingsComponent.unMappedStock.findIndex(item => item === unmappedStockItem);
        if (currentIndex !== -1 && currentIndex < this.adminStockMappingsComponent.unMappedStock.length - 1) {
          const nextItem = this.adminStockMappingsComponent.unMappedStock[currentIndex+1];
          this.adminMappingService.unmappedStockItem = nextItem     
        }
      }
      this.adminStockMappingsComponent.refreshUnMappedStockTable(unmappedStockItem, unmappedStockItem.clientId);      
      }, error => {
          this.notification.handleError(error);
          this.isMapping = false;

        })
  }

  mapCustomStock(unmappedStockItem: UnMappedStock, msfIdOfExistingStock: number, stockTypeId: number, mapType: number, close: boolean, next: boolean) {
    this.isMapping = true;
    const customStockItem: CustomStockToBeMapped = {
      clientId: unmappedStockItem.clientId,
      description: unmappedStockItem.description,
      msfid: msfIdOfExistingStock,
      stockCode: unmappedStockItem.stockCode,
      stockTypeId: stockTypeId
    };
    
    this.adminMappingService.mapCustomStock(customStockItem).subscribe(res => {
      this.notification.showSuccess("Changes saved successfully");
      this.isMapping = false;
      this.selectedCustomMap = null;

      if (close) {
        this.adminMappingService.currentVisibility = false;
      }
      if (next) {
        this.nextTyre(unmappedStockItem);
      }
      this.adminStockMappingsComponent.refreshUnMappedStockTable(unmappedStockItem, unmappedStockItem.clientId);
    },
      error => {
        this.notification.handleError(error);
        this.isMapping = false;
      })
  }

  addCustomStockMapping(stockCode: string, description: string, stockType: StockType, unmappedStock : UnMappedStock) {
    this.isMapping = true;
    let nmsfId = stockType.msfId;
    let stockTypeId = stockType.id;
    let newCustomStockMapping = new NewCustomStockMapping();

    newCustomStockMapping.clientId = this.adminMappingService.currentClientId;
    newCustomStockMapping.stockCode = stockCode;
    newCustomStockMapping.description = description;
    newCustomStockMapping.nmsfId = nmsfId;
    newCustomStockMapping.mappingTypeId = 1;
    newCustomStockMapping.userId = 997;
    newCustomStockMapping.officialStock = '';
    newCustomStockMapping.stockTypeId = stockTypeId;

    this.adminMappingService.createCustomStockMapping(newCustomStockMapping).subscribe(res => {
      this.notification.showSuccess("Changes saved successfully");
      this.mapCustomStock(unmappedStock, nmsfId, stockTypeId, 1, true, false);
      this.isMapping = false;
      this.isAddCustomStockOpen = false;
      this.selectedCustomMap= null;
      this.clearForm();

    },
      error => {
        this.notification.handleError(error);
        this.isMapping = false;
      })
  }

  clearForm(): void {
    this.customStockCode = '';
    this.customStockType = { id: 0, name: 'null', msfId: 0, isVisible: false };
    this.customDescription = '';
  }

  searchedTerm: string = "";

  searchActiveStock(value: string) {
    if (!value) {
      this.searchedTerm = "";
      return;
    }
    this.searchedTerm = value;
    if (value && value.length > 2) {

      this.filteredStock = this.activeStock.filter(e =>
        (e.stockCode && e.stockCode.toLowerCase().includes(value.toLowerCase())) ||
        (e.description && e.description.toLowerCase().includes(value.toLowerCase())) ||
        (e.brand && e.brand.toLowerCase().includes(value.toLowerCase())) ||
        (e.genCode && e.genCode.toLowerCase().includes(value.toLowerCase())) ||
        (e.msfid && (e.msfid == Number(value) || (typeof e.msfid === 'string' && e.msfid === value))) ||
        (e.genCode + ' ' + e.brand + ' ' + e.description + ' (' + e.stockCode + ')').toLowerCase().includes(value.toLowerCase())).map(e => {
          return { key: + e.msfid, name: e.genCode + ' ' + e.brand + ' ' + e.description + ' (' + e.stockCode + ')' }
        });
    }

  }

  searchActiveCustomStock(value: string) {
    if (!value) {
      this.searchedTerm = "";
      return;
    }
    this.searchedTerm = value;
    if (value && value.length > 2) {

      this.filteredStock = this.activeCustomStock.filter(e =>
        (e.stockCode && e.stockCode.toLowerCase().includes(value.toLowerCase())) ||
        (e.description && e.description.toLowerCase().includes(value.toLowerCase())) ||
        (e.msfid && (e.msfid == Number(value) || (typeof e.msfid === 'string' && e.msfid === value))) ||
        (e.description + ' (' + e.stockCode + ')').toLowerCase().includes(value.toLowerCase())).map(e => {
          return { key: + e.msfid, name: e.description + ' (' + e.stockCode + ')' }
        });
    }
  }
  setTab(tab: string) {
    if (tab === 'tyre') {
      this.isCustomMappingTab = false;
    } else if (tab === 'custom') {
      this.isCustomMappingTab = true;
    }
  }

  filterActiveStockAdvanced(){
    if (this.filterTerm === "") {
      this.activeStock = this.activeStockTemp;
  }else{
      this.activeStockVeryTemp = this.activeStockTemp;
      this.activeStockVeryTemp = this.activeStockVeryTemp.filter(stock => stock.description.toLowerCase().includes(this.filterTerm.toLowerCase()));
      this.activeStock = this.activeStockVeryTemp;
  }
  }

  nextTyre(unmappedStockItem: UnMappedStock) {
    const currentIndex = this.adminStockMappingsComponent.unMappedStock.findIndex(item => item === unmappedStockItem);
    if (currentIndex !== -1 && currentIndex < this.adminStockMappingsComponent.unMappedStock.length - 1) 
      {
      const nextItem = this.adminStockMappingsComponent.unMappedStock[currentIndex+1];
      this.adminMappingService.unmappedStockItem = nextItem
    } else {
      this.notification.showInfo("No more items to map");
    }
  }

 isThereNextTyre(unmappedStockItem: UnMappedStock) {
  const currentIndex = this.adminStockMappingsComponent.unMappedStock.findIndex(item => item === unmappedStockItem);
  if (currentIndex !== -1 && currentIndex < this.adminStockMappingsComponent.unMappedStock.length - 1) 
    {
    const nextItem = this.adminStockMappingsComponent.unMappedStock[currentIndex+1];
    if (nextItem) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

openNMSFAdd(){
  this.isNmsfAddOpen = true;
  if (this.adminMappingService.unmappedStockItem.clientId) {
    this.itemToAdd.locationId = this.adminMappingService.unmappedStockItem.clientId;
  }
  else{
    this.itemToAdd.locationId = 0;
  }
  
  this.itemToAdd.description =this.adminMappingService.unmappedStockItem.description;
  this.itemToAdd.stock_code =this.adminMappingService.unmappedStockItem.stockCode;
  this.itemToAdd.searchedGenCode = this.searchedTerm;
}

mapUsedStockItem(unmappedStockItem: UnMappedStock, msfIdOfExistingStock: number, classifictionId:number, close: boolean, next: boolean){
  this.isMapping = true;

  const usedStockItem = new UsedStockItemToBeMapped();
  usedStockItem.clientId = unmappedStockItem.clientId;
  usedStockItem.description = unmappedStockItem.description;
  usedStockItem.msfId = msfIdOfExistingStock;
  usedStockItem.stockCode = unmappedStockItem.stockCode;
  usedStockItem.classificationId = classifictionId;
  usedStockItem.soh = unmappedStockItem.soh;
  usedStockItem.cost= unmappedStockItem.cost;
  
  this.adminMappingService.mapUsedStockItem(usedStockItem).subscribe(res => {
    this.notification.showSuccess("Changes saved successfully");
    this.isMapping = false;
    this.selectedMap = null;
    if (close) {
      this.adminMappingService.currentVisibility = false;
    }

    if (next) {
      const currentIndex = this.adminStockMappingsComponent.unMappedStock.findIndex(item => item === unmappedStockItem);
      if (currentIndex !== -1 && currentIndex < this.adminStockMappingsComponent.unMappedStock.length - 1) {
        const nextItem = this.adminStockMappingsComponent.unMappedStock[currentIndex+1];
        this.adminMappingService.unmappedStockItem = nextItem     
      }
    }
    this.adminStockMappingsComponent.refreshUnMappedStockTable(unmappedStockItem, unmappedStockItem.clientId);      
    }, error => {
        this.notification.handleError(error);
        this.isMapping = false;

      })
}

setSelectedUsedStockClassification(usedStockClassification: UsedStockClassification){
  this.selectedUsedStockClassification = usedStockClassification;

}
}
